import { styled, disabledProps } from "../../../styled-components";

export const BasePickerStyle = styled.div<{
    isEnabled?: boolean;
    isPlaceholder?: boolean;
    progressPercentage?: number;
}>`
    height: 44px;
    text-align: start;

    padding: 0 12px;

    display: flex;
    flex-direction: row;

    justify-content: stretch;
    align-items: center;

    ${p => p.isEnabled === false && disabledProps}

    border-radius: ${p => p.theme.preferredRoundingRadius}px;
    background-color: ${p => p.theme.picker.backgroundColor};

    transition: box-shadow 150ms ease-in-out;

    @media (hover: hover) {
        :hover {
            background-color: ${p => p.theme.picker.hoverBgColor};
        }
    }

    :focus {
        background-color: ${p => p.theme.picker.hoverBgColor};
        box-shadow: 0 0 0 2px ${p => p.theme.primaryAccentColor};
        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
            .input-wrap {
                box-shadow: 0 0 0 1.5px ${p => p.theme.primaryAccentColor};
            }
        }
    }

    :active {
        background-color: ${p => p.theme.picker.activeBgColor};
    }

    cursor: pointer;
    position: relative;
    overflow: hidden;

    input:focus + label > & {
        background-color: ${p => p.theme.picker.hoverBgColor};
    }

    .main-content {
        flex: 1;
        ${p => p.theme.fontStyles.Body4}

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        color: ${p => p.theme.fgColorDark};

        ${p => p.isPlaceholder === true && `opacity: 0.4`};

        cursor: pointer;

        & input {
            opacity: 0;
            position: absolute;
        }

        label {
            cursor: pointer;
        }

        input[type="file"],
        input[type="file"]::-webkit-file-upload-button {
            cursor: pointer;
        }
    }

    .footer {
        margin-top: 4px;

        ${p => p.theme.fontStyles.Body6Fixed};
        min-height: 17px;
        color: ${p => p.theme.fgColorLight};
    }

    .rightItem {
        flex-grow: 0;
        flex-shrink: 0;
        color: ${p => p.theme.fgColorLight};
        margin-left: 10px;
    }

    .leftItem {
        color: ${p => p.theme.fgColorMedium};
        flex-grow: 0;
        flex-shrink: 0;
        margin-right: 10px;

        .image {
            border-radius: 5px;
            width: 32px;
            height: 32px;
            object-fit: cover;
        }
    }

    .preview-wrapper > div {
        display: block;
    }

    .progress-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        width: ${p => p.progressPercentage ?? 0}%;

        z-index: 50;
        height: 3px;

        background-color: ${p => p.theme.primaryAccentColor};
    }
`;
